export const scrollDownToSection = (ref) => {
  const offsetHeader = 88
  return window.scrollTo({
    top: ref.current?.offsetTop - offsetHeader,
    behavior: 'smooth'
  })
}
